import { render, staticRenderFns } from "./registration-view.vue?vue&type=template&id=6837eb34&scoped=true&"
import script from "./registration-view.vue?vue&type=script&lang=js&"
export * from "./registration-view.vue?vue&type=script&lang=js&"
import style0 from "./registration-view.vue?vue&type=style&index=0&id=6837eb34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6837eb34",
  null
  
)

export default component.exports